/**
 * Checks if the application is running in development mode on localhost in a browser environment.
 *
 * @returns {boolean} True if all conditions are met:
 *   - NODE_ENV is 'development'
 *   - window is defined (browser environment)
 *   - hostname is localhost or 127.0.0.1
 */
export const isLocalDevelopment = (): boolean => {
  return isDevelopment() && isBrowser() && isLocalHost();
};

/**
 * Checks if the application is running on localhost (regardless of environment).
 *
 * @returns {boolean} True if running on localhost in a browser environment
 */
export const isLocalHost = (): boolean => {
  // Check if running in browser (window is defined)
  const inBrowser = isBrowser();

  // Check if on localhost
  return (
    inBrowser &&
    (window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1' ||
      window.location.hostname === '0.0.0.0' ||
      window.location.hostname.startsWith('192.168.') ||
      window.location.hostname.endsWith('.local'))
  );
};

/**
 * Checks if the NODE_ENV is set to development.
 *
 * @returns {boolean} True if NODE_ENV is 'development'
 */
export const isDevelopment = (): boolean => {
  return process.env.NODE_ENV === 'development';
};

/**
 * Checks if the code is running in a browser environment.
 *
 * @returns {boolean} True if window is defined
 */
export const isBrowser = (): boolean => {
  return typeof window !== 'undefined';
};
